export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "5af07fea94msh66ccd3656efe563p16ea95jsnaee94329973e",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};
export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "77eec6520e737e504a081a4c2b3b60d9"; // enter your key from openweather API
